// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DY5n","col":"styles_col__1jAQm"};